var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-cabinet-verification-finance-general"},[_c('ui-form',{attrs:{"model":_vm.fieldsFiltered,"validation":_vm.validation,"submit-handler":_vm.submitFormData,"gap":"wide"},on:{"update":_vm.updateFormData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }